<template>
  <b-navbar toggleable fixed="top" :variant=navvar type="dark">
    <b-navbar-brand href="https://payoo.app"><img src="../assets/Logo Payoo_Logo Payoo blanc.png" class="d-inline-block align-top logo-img-width "  alt="payOO">
    </b-navbar-brand>
    <b-navbar-nav v-if="enviro=='staging'" class="full-only">TEST ENVIRONMENT</b-navbar-nav>

    <b-navbar-nav class="ml-auto" style="display:inline;">
      <b-navbar-toggle v-if="$route.name=='Orders'&&statusoptions" target="filters-sorting" style="color:white;" @>
        <template v-slot:default="{ expanded }">
          <span class="full-only"> Filters & Sorting</span>
          <b-icon v-if="expanded" icon="caret-up-fill" shift-v="-4" font-scale="2"></b-icon>
          <b-icon v-else icon="caret-down-fill" shift-v="-4" font-scale="2"></b-icon>
        </template>
      </b-navbar-toggle>
      <b-button variant="dark" v-b-toggle.nav-sidebar><b-icon icon="justify" font-scale="3"></b-icon></b-button>
    </b-navbar-nav>

    <b-collapse id="filters-sorting" is-nav @show="emitShowFilters(true)" @hide="emitShowFilters(false)">
      <b-container fluid>
        <b-navbar-nav class="filters">
          <b-nav-form @submit="onSubmit">
            <b-row>
              <b-col sm="12" md="4">
                <b-form-group label="Filter Order Status">
                  <b-form-checkbox-group
                    v-model="status_filter"
                    :options="status_options"
                    name="filter-status"
                    @input="emitStatusFilter"
                    stacked
                    :disabled="showoverlay"
                  ></b-form-checkbox-group>
                </b-form-group>
              </b-col>
              <b-col sm="12" md="4"  class="mt-2">
                <b-form-group label="Filters">
                  <b-form-select v-model="textFilterType" :options="textFilterOptions" class="custfilter" :disabled="showoverlay"></b-form-select>
                  <b-form-input ref="filter" v-model="textFilterValue" placeholder="Type to search" class="custfilter mt-3" :disabled="showoverlay" @change="emitTextFilter"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="12" md="4" class="mt-2">
                Sort:
                <b-form-select v-model="sortfield" :options="sortoptions" :disabled="showoverlay" @change="emitSortOrder"></b-form-select>
                <div class="ascdesc">
                  <b-form-group>Asc<b-form-checkbox v-model="sortbydesc" switch :disabled="showoverlay" @input="emitSortOrder">Desc</b-form-checkbox></b-form-group>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col><b-button variant="light" @click="clearFilters">Clear</b-button></b-col>
            </b-row>
          </b-nav-form>
        </b-navbar-nav>
      </b-container>
    </b-collapse>
    <SideBar></SideBar>
  </b-navbar>
</template>

<script>
// @ is an alias to /src
import SideBar from '@/components/SideBar.vue'

export default {
  name: 'Nav',
  props: ['statusoptions', 'showoverlay'],
  components: {
    SideBar
  },
  data() {
    return {
      status_filter: [],
      sortoptions: [
        {text: 'Sort by', value: 0, disabled: true},
        {text: 'Order number', value: 'order_number'},
        {text: 'Pickup time', value: 'pickup_time'},
        {text: 'Time ordered', value: 'time_taken'},
        {text: 'Order total', value: 'total'},
        {text: 'Order status', value: 'order_status'},
      ],
      sortfield: 0,
      sortbydesc: false,
      textFilterOptions: [
        { value: 'ordnum', text: 'Order Number' },
        { value: 'cusname', text: 'Customer Name' },
        { value: 'cusnum', text: 'Customer Phone' }
      ],
      textFilterType: 'ordnum',
      textFilterValue: ''
    }
  },

  computed: {
    enviro: function() {
      if (process.env.VUE_APP_BASE_URL.includes('stage')) {
        return 'staging';
      } else {
        return 'production';
      }
    },

    navvar: function() {
      if (process.env.VUE_APP_BASE_URL.includes('stage')) {
        return 'warning';
      } else {
        return 'dark';
      }
    },

    status_options: function() {
      if (this.statusoptions) {
        delete this.statusoptions[0];
        return this.statusoptions;
      }
      else return [];
    },

  },

  methods: {
    emitShowFilters(vis) {
        this.$emit('show-filters-emit', vis);
        if (vis==true) {
          this.$refs.filter.focus();
        }
    },

    emitStatusFilter() {
      this.$emit('statusemit', this.status_filter);
    },

    emitTextFilter() {
      this.$emit('text-filter-emit', this.textFilterValue, this.textFilterType);
    },

    emitSortOrder() {
      this.$emit('sortorderemit', this.sortfield, this.sortbydesc);
    },

    onSubmit(evt) {
      evt.preventDefault()
    },

    clearFilters() {
      this.status_filter=[];
      this.emitStatusFilter();
      this.textFilterValue='';
      this.emitTextFilter();
    }

  }

}
</script>

<style>
  .logo-img-width {
    height: 50px;
  }
  .filters {
    color: white;
    display: block !important;
  }

  .filters label {
    justify-content: left;
  }

  .custfilter {
    display: block !important;
    width: 100% !important;
  }

  .ascdesc .bv-no-focus-ring {
    display: inline-flex;
  }

  .ascdesc .custom-switch {
    padding-left: 3rem;
  }

  @media (max-width: 767px) {
    .full-only {
      display: none;
    }
    .logo-img-width {
    height: 40px;
  }
  }

</style>
